<template>
  <div class="wms-ball-steps">
    <div class="wms-ball-steps-card" v-for="item in steps">
      <div class="wms-ball-steps-card-ball">
        <div class="wms-ball-steps-card-ball-title">{{item.title}}</div>
        <div class="wms-ball-steps-card-ball-content">{{item.number}}</div>
      </div>
      <div class="wms-ball-steps-card-line"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WMSBallStepH',
    props: {
      steps: {
        type: Array,
        default() {
          return []
        }
      }
    }
  }
</script>

<style scoped>
  .wms-ball-steps {
    height: 100%;
    display: flex;
  }

  .wms-ball-steps-card {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .wms-ball-steps-card-ball {
    height: 70px;
    width: 70px;
    border-radius: 50%;
    background-color: #eee;
    flex: none;
  }

  .wms-ball-steps-card-line {
    background-color: #eee;
    height: 2px;
    flex: 1;
  }

  .wms-ball-steps > .wms-ball-steps-card:last-of-type {
    width: 70px;
    flex: none;
  }

  .wms-ball-steps-card-ball-title {
    font-size: 14px;
    height: 50%;
    text-align: center;
    padding-top: 20px;
  }

  .wms-ball-steps-card-ball-content {
    height: 50%;
    text-align: center;
  }
</style>